<template> 
    <v-app-bar
		app
		color="white"
		class="px-xs-5 elevation-0"
		height="40"
        :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr' "
    >

		<!-- title -->
		<div class="d-flex flex-grow-1">
			<h1 class="text-h6 primary--text text-capitalize">
				{{ $route.name !== 'login' ?  getRouteTitle() : '' }}
			</h1>
		</div>
        <!-- <v-menu 
			v-model="lang"
			offset-y
		>	
			<template v-slot:activator="{ on, attrs }">
				<v-btn 
					v-bind="attrs"
					v-on="on"
					class="blue-dark--text primary--text"
					elevation="0"
					color="transparent"
				>
					<v-icon small color="primary"> mdi-earth  </v-icon>
					{{ $i18n.locale }}
				</v-btn>
			</template>	
			<v-list dense nav>
				<template>
					<v-list-item @click="$emit('change-lang'); $i18n.locale= 'ar'"> Ar </v-list-item>
					<v-list-item @click="$emit('change-lang'); $i18n.locale= 'en'"> En </v-list-item>
				</template>
			</v-list>
		</v-menu> -->
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    dark
                    text
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="me-1"> mdi-account-circle </v-icon>
                    {{userName}}
                </v-btn>
            </template>

            <v-list class="px-0 py-0">
                <v-list-item class="px-0" >
                    <v-card
                        max-width="400"
                        class="mx-auto"
                    >
                        <v-card-title class="py-1">
                            <v-img 
                                src="@/assets/male.jpg" 
                                contain
								max-width="50"
								width="50"
								min-width="50"  
                                class="me-4"
                            />
                            <span class="text-body"> {{userName}} </span>
                        </v-card-title>
                        <v-divider></v-divider>

                        <v-list>
                            <v-list-item v-if="!firstLevel" >
                                <v-list-item-content>
                                    <v-text-field
                                        v-model="vacations"
                                    	:label="$t('vacations-balance')"
                                    	dense
                                    	outlined
                                    	hide-details="auto"
                                    	disabled
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            
                            <v-divider v-if="!firstLevel" class="mx-2"></v-divider>
                            
                            <!-- <v-list-item @click="vacationDialog = true">
                                <v-list-item-title>
                                    <v-icon color="orange">
                                        mdi-calendar
                                    </v-icon>
                                    Day off request
                                </v-list-item-title>
                            </v-list-item> -->

                            <v-divider v-if="!firstLevel" class="mx-2"></v-divider>

                            <v-list-item @click="logout()" >
                                <v-list-item-title>
                                    <v-icon color="orange">
                                        mdi-logout
                                    </v-icon>
                                    {{$t('logout')}}
                                </v-list-item-title>
                            
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
    
</template>

<script>
import routes from '@/router/routes';
import { mapState } from 'vuex'
import { requestTypes } from '@/helpers/enums'
import { firstLevel } from '@/configs/global.config'
export default {
    name:'navbar',

    data(){
        return {
            submitLoading: false,
            selectedItem: -1,
            items:[
                { title: 'Logout' },
            ],
            on: false,
            vacationDialog: false,
            Days: [],
            vacations: null,
            requestTypes,
            firstLevel,
            lang: false
        }
    },

    watch: {
        '$i18n.locale'(){
            window.localStorage.setItem('lang', this.$i18n.locale);
            if (window.localStorage.getItem('lang') === "ar") {      
                document.querySelector('html').dir = "rtl";
            } else {
                document.querySelector('html').dir = "ltr";
            }
        }
    },

    computed:{
        ...mapState({
            userName: state => state.auth.userData.username,
            userLogin: state => state.auth.self.employeeId
        })
    },

    methods:{
		getRouteTitle() {
            const translateKey = this.$route.meta.i18nKey;
            const title = translateKey ? this.$t(`routes.${translateKey}`) : null;
            if (this.$route.params.type) {
                return this.$route.params.type + ' ' + title;
            } else {
                return title
            }
		},

        logout(){
            this.$store.dispatch('auth/logout');
            this.$router.replace({ name:'login' })
        }
    },

    created() {
        this.$store.dispatch('leaveManagement/fetchCount', { employeeId: this.userLogin }).then((data) => {
            this.vacations = data.remainingNumberOfLeaves
        })

        if (window.localStorage === '') {
            window.localStorage.setItem('lang', 'en')
        }
        this.$i18n.locale = window.localStorage.getItem('lang')
        if (window.localStorage.getItem('lang') === "ar") {    
            document.querySelector('html').dir = "rtl"
        } else {
            document.querySelector('html').dir = "ltr"
        }
    }
    
}
</script>

<style lang="scss">
@import '../scss/variables.scss';
#companey-name{
    font-weight: bolder;
    // line-height: 20px;
    h1{
        span:nth-child(1){
            font-size: 25px ;
            margin-bottom: -5px;
            line-height: 30px;
        }
        span:nth-child(2){
            font-size: 16px;
        }
    }
}
</style>